import moment from 'moment'

const user = () => JSON.parse(localStorage.getItem('user'))

const isAuthenticated = () => {
  const _user = user()

  return _user && moment().isBefore(moment(_user.expires_at))
}

const logout = () => {
  return new Promise((resolve, reject) => {
    try {
      localStorage.removeItem('user')
      resolve()
    } catch (error) {
      reject(error)
    }
  })
}

export { user, isAuthenticated, logout }
